import Logo from "../Logo";
import styles from './Navigation.module.css'
import cx from "classnames";
import {Link} from "../../types/Link";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {useGlobalContext} from "../../contexts/globalContext";


type NavigationProps = {
    active: Link,
    setActive: (link: Link) => void,
    links: Link[]
}

const Navigation = ({active, setActive, links}: NavigationProps) => {
    const {t} = useTranslation(['nav'])
    const [checked, setChecked] = useState<boolean>(false)

    const {fullscreen, setFullscreen} = useGlobalContext()

    useEffect(() => {
        setChecked(false)
    }, [active])

    return (
        <nav className={cx(styles["zr-nav"], fullscreen && styles["zr-sticky-nav"])}>
            <div className={cx(styles["zr-logo"])}>
                <Logo/>
                <span>ZR Customizer</span>
            </div>
            <div className={cx(styles["zr-desktop-nav"])}>
                <ul>
                    {links.map((link: Link) => (
                        <li className={cx(active.number === link.number && styles['zr-active'])} key={link.number} onClick={() => setActive(link)}>{t(link.name)}</li>
                    ))}
                    <li className={cx(styles["zr-fullscreen-icon"])} onClick={() => {setFullscreen((prev: boolean) => !prev)}}>&#x26F6;</li>
                </ul>
            </div>
            <label className={cx(styles["zr-burger-menu"])} htmlFor="zr-burger">
                <input className={cx(styles["zr-hidden"])} id="zr-burger" type="checkbox" onChange={() => setChecked(!checked)}/><span/>
            </label>
            <div className={cx(styles["zr-mobile-nav"], checked && styles['zr-checked'])}>
                <ul>
                    {links.map((link: Link) => (
                        <li className={cx(active.number === link.number && styles['zr-active'])} key={link.number} onClick={() => setActive(link)}>{t(link.name)}</li>
                    ))}
                    <li
                        className={cx(styles["zr-fullscreen-icon-mobile"])}
                        onClick={() => {
                            setFullscreen((prev: boolean) => !prev)
                            setChecked(false)
                        }}
                    >&#x26F6; Fullscreen</li>
                </ul>
            </div>
        </nav>
    )
}

export default Navigation;
